import {
  SERVICE_ID_ESSENTIAL_ULTIMATE_ANNUAL,
  SERVICE_ID_ESSENTIAL_ANNUAL_VIP,
  SERVICE_ID_ULTIMATE_ANNUAL,
  SERVICE_ID_ULTIMATE_ANNUAL_VIP,
} from './getServiceProperty';

export default (serviceId) => {
  let newServiceId = serviceId;

  if (serviceId === SERVICE_ID_ULTIMATE_ANNUAL_VIP) {
    newServiceId = SERVICE_ID_ULTIMATE_ANNUAL;
  }

  if (serviceId === SERVICE_ID_ESSENTIAL_ANNUAL_VIP) {
    newServiceId = SERVICE_ID_ESSENTIAL_ULTIMATE_ANNUAL;
  }

  return newServiceId;
};
